import React from "react";
import axios from "axios";
import { I18n } from "i18n-js";
import * as locales from "../../../locales.json";
const i18n = new I18n(locales);
i18n.defaultLocale = "en";
i18n.locale = (window as any).locale || "";
import { Link } from "react-router-dom";

import setUpAxios from "../../../helperFunctions/helperFunctions";

declare var Components: any;

interface MinigraphCardProps {
  devMode: boolean;
  children: React.ReactNode;
  title: string;
  url: string;
  chartName: string;
}

export default class MinigraphCard extends React.Component<
  MinigraphCardProps,
  any
> {
  static defaultProps = {
    children: null,
    title: "",
    devMode: false,
    url: "",
    chartName: "",
  };

  componentDidMount() {
    setUpAxios();
  }

  render() {
    return (
      <div className="card minigraph-card">
        <div className="card-header">
          {this.renderGatedTitleLink()}
          {this.renderActions()}
        </div>
        <div className="card-content">{this.props.children}</div>
      </div>
    );
  }

  renderActions = () => {
    return (
      <div className="minigraph-actions">
        {this.renderGatedViewMoreLink()}
        {this.renderFeedbackLink()}
      </div>
    );
  };

  renderGatedTitleLink = () => {
    if (this.props.devMode) {
      return (
        <Link to={`/analytics/dashboard/${this.props.chartName}`}>
          {this.props.title}
        </Link>
      );
    }

    return <a href={this.props.url}>{this.props.title}</a>;
  };

  renderGatedViewMoreLink = () => {
    if (this.props.devMode) {
      return (
        <Link
          className="graph-expand-link"
          to={`/analytics/dashboard/${this.props.chartName}`}
        >
          {i18n.translate("analyticsv2.view_more")}
        </Link>
      );
    }

    return (
      <a href={this.props.url} className="graph-expand-link">
        {i18n.translate("analyticsv2.view_more")}
      </a>
    );
  };

  renderFeedbackLink = () => {
    return (
      <>
        <a
          href="#"
          className="graph-expand-link feedback"
          data-toggle="dropdown"
          aria-label="feedback-dropdown"
        >
          <i className="fas fa-ellipsis-h" />
        </a>
        {this.renderDropdown()}
      </>
    );
  };

  renderDropdown = () => {
    return (
      <ul className="dropdown-menu">
        <div className="feedback-blurb">
          {i18n.translate("analyticsv2.feedback.helpful")}
        </div>
        <li>
          <a className="report-flag" onClick={this.handleSubmitFeedback(1)}>
            <i className="fas fa-thumbs-up" />
            {i18n.translate("simple_form.yes")}
          </a>
        </li>
        <li>
          <a className="report-flag" onClick={this.handleSubmitFeedback(-1)}>
            <i className="fas fa-thumbs-down" />
            {i18n.translate("simple_form.no")}
          </a>
        </li>
      </ul>
    );
  };

  handleSubmitFeedback = (feedback) => {
    return () => {
      const data = {
        analytics_chart_feedback: {
          chart: this.props.chartName,
          feedback,
        },
      };
      axios.post("/analytics_chart_feedbacks", data).then(() => {
        this.dispatchGrowler();
      });
    };
  };

  dispatchGrowler = () => {
    Components.Growler.get("notifications").send(
      "success",
      i18n.translate("analyticsv2.feedback.thank_you")
    );
  };
}
